import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, browserHistory, applyRouterMiddleware} from 'react-router';
import Relay from 'react-relay';
import useRelay from 'react-router-relay';

import App from './App/App';
import Login from './Login/Login';
import MailingLists from './Routes/MailingLists/MailingLists';
import MailingListDetails from './Routes/MailingListDetails/MailingListDetails';

import 'react-mdl/extra/material.css';
import 'react-mdl/extra/material.js';

import AuthNetworkLayer from './auth-net-layer';

let auth = new AuthNetworkLayer('https://us-central1-ev-scouts-138.cloudfunctions.net/graphql', {
    oauth2: {
        client_id: '312127016989-96m03sslcjiahf5lu04kd6e8cs543rf1.apps.googleusercontent.com',
        redirect_uri: `${window.location.origin}/oauth2callback.html`,
        scope: 'email',
    },
    onautherr: (err) => {
        render(err);
    },
});

Relay.injectNetworkLayer(auth);

init();

function init() {
    auth.login()
        .then(() => render())
        .catch(err => renderError(err));
}

function render() {
    _render(
        <Router
            history={browserHistory}
            render={applyRouterMiddleware(useRelay)}
            environment={Relay.Store}
        >
            <Route
                path="/"
                component={App}
            >
                <Route
                    path="/mailing-lists"
                    component={MailingLists}
                />
                <Route
                    path="/mailing-lists/:address"
                    component={MailingListDetails}
                />
            </Route>
        </Router>
    );
}

function renderError(err) {
    _render(<Login error={err} login={init} />);
}

function _render(root) {
    ReactDOM.render(root, document.getElementById('root'));
}



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/